import React, { useState } from 'react';
import { useTransactions } from '../contexts/TransactionContext';
import { useToast } from '../contexts/ToastContext';
import Icon from './Icon';

const TransactionForm = () => {
  const { addTransaction } = useTransactions();
  const { showToast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const getLocalDateString = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState({
    type: 'expense',
    amount: '',
    category: '',
    description: '',
    date: getLocalDateString()
  });

  const categories = {
    expense: ['식비', '주거비', '교통비', '통신비', '공과금', '쇼핑', '생활용품', '뷰티/미용', '여행/레저', '문화생활', '의료/약국', '교육/강의', '경조사비', '반려동물', '금융/투자', '기타'],
    income: ['급여', '부업', '투자수익', '용돈', '상여금', '기타']
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.amount || !formData.category) {
      showToast({ type: 'warning', message: '금액과 카테고리를 입력해주세요.' });
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      await addTransaction({
        ...formData,
        amount: parseFloat(formData.amount)
      });
      
      setFormData({
        type: 'expense',
        amount: '',
        category: '',
        description: '',
        date: getLocalDateString()
      });
    } catch (error) {
      console.error('거래 추가 실패:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'type' && { category: '' })
    }));
  };

  return (
    <div className="card">
      <h2>거래 내역 추가</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>유형</label>
          <select name="type" value={formData.type} onChange={handleChange}>
            <option value="expense">지출</option>
            <option value="income">수입</option>
          </select>
        </div>

        <div className="form-group">
          <label>금액</label>
          <input
            type="number"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            placeholder="금액을 입력하세요"
            required
          />
        </div>

        <div className="form-group">
          <label>카테고리</label>
          <select name="category" value={formData.category} onChange={handleChange} required>
            <option value="">카테고리 선택</option>
            {categories[formData.type].map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>설명</label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="설명을 입력하세요"
          />
        </div>

        <div className="form-group">
          <label>날짜</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        <button 
          type="submit" 
          className="btn-primary btn-full-width"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="loading-spinner"></span>
              추가 중...
            </>
          ) : (
            <>
              <Icon name="add_circle" /> 추가하기
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default TransactionForm;